import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

const statusVariants = cva(
  "inline-flex items-center gap-1.5 text-xs font-medium font-mono uppercase tracking-wider",
  {
    variants: {
      variant: {
        active: "text-status-active",
        warning: "text-status-warning",
        critical: "text-status-critical",
        inactive: "text-status-inactive",
      },
    },
    defaultVariants: {
      variant: "active",
    },
  }
);

export function StatusIndicator({ variant, label, pulse = false, className }) {
  return (
    <span className={cn(statusVariants({ variant }), className)}>
      <span
        className={cn(
          "h-1.5 w-1.5 rounded-full",
          variant === "active" && "bg-status-active",
          variant === "warning" && "bg-status-warning",
          variant === "critical" && "bg-status-critical",
          variant === "inactive" && "bg-status-inactive",
          pulse && "animate-status-pulse"
        )}
      />
      {label}
    </span>
  );
}
